/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { BaseModuleBody } from './base-module-body';
import { EntitlementType } from './entitlement-type';
import { FieldChange } from './field-change';
import { TargetPlatform } from './target-platform';

/**
 * 
 * @export
 * @interface ModuleChange
 */
export interface ModuleChange {
    /**
     * 
     * @type {string}
     * @memberof ModuleChange
     */
    moduleId: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleChange
     */
    moduleType: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleChange
     */
    slug: string;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof ModuleChange
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof ModuleChange
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {string}
     * @memberof ModuleChange
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ModuleChange
     */
    changeType: ModuleChangeChangeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ModuleChange
     */
    oldPosition?: number;
    /**
     * 
     * @type {number}
     * @memberof ModuleChange
     */
    newPosition?: number;
    /**
     * 
     * @type {Array<FieldChange>}
     * @memberof ModuleChange
     */
    fieldChanges?: Array<FieldChange>;
    /**
     * 
     * @type {BaseModuleBody}
     * @memberof ModuleChange
     */
    oldModule?: BaseModuleBody;
    /**
     * 
     * @type {BaseModuleBody}
     * @memberof ModuleChange
     */
    newModule?: BaseModuleBody;
}

/**
    * @export
    * @enum {string}
    */
export enum ModuleChangeChangeTypeEnum {
    ADDED = 'ADDED',
    REMOVED = 'REMOVED',
    MODIFIED = 'MODIFIED',
    MOVED = 'MOVED',
    UNCHANGED = 'UNCHANGED'
}



